import React from "react";
import { cn } from "@/lib/utils";

/**
 * SuiteQuickBar — Barra dei comandi rapidi (Cruscotto-only).
 *
 * Master Shell v2 · v1.11.0 (28/07/2026 · Brand Book v1.0)
 * ========================================================
 * Renderizzata ESCLUSIVAMENTE nel Cruscotto per accesso rapido alle
 * 7 azioni operative principali.
 * - 1 pulsante primario (verde brand)
 * - 6 pulsanti secondari (bianchi con bordo sottile)
 * Scorrevole orizzontalmente su viewport ridotti.
 *
 * Props:
 *   - primary: { icon, label, onClick, testid }
 *   - secondary: [{ icon, label, onClick, testid }] (max 6 raccomandato)
 */
export function SuiteQuickBar({ primary, secondary = [], className }) {
  return (
    <div
      className={cn("suite-quickbar w-full shrink-0", className)}
      data-testid="suite-quickbar"
      style={{
        padding: "10px 20px",
        backgroundColor: "#FFFFFF",
        borderBottom: "1px solid #E5E7EB",
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: 8,
          overflowX: "auto",
          overflowY: "hidden",
          scrollbarWidth: "thin",
        }}
      >
        {primary && (
          <>
            <button
              type="button"
              onClick={primary.onClick}
              data-testid={primary.testid || "quickbar-primary"}
              className="suite-quickbar-primary"
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: 8,
                padding: "0 16px",
                height: 40,
                borderRadius: 8,
                backgroundColor: "var(--gis-green)",
                color: "#fff",
                border: "none",
                fontSize: 13,
                fontWeight: 700,
                cursor: "pointer",
                fontFamily: "var(--gis-font-heading)",
                boxShadow: "0 2px 6px rgba(11,107,79,0.18)",
                whiteSpace: "nowrap",
                flexShrink: 0,
                letterSpacing: "-0.005em",
              }}
              onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "var(--gis-green-hover)")}
              onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "var(--gis-green)")}
            >
              {primary.icon && <primary.icon size={16} strokeWidth={2} />}
              {primary.label}
            </button>
            <div style={{ width: 1, height: 24, backgroundColor: "#E5E7EB", margin: "0 4px", flexShrink: 0 }} />
          </>
        )}
        {secondary.map((s, idx) => (
          <button
            key={s.testid || idx}
            type="button"
            onClick={s.onClick}
            data-testid={s.testid || `quickbar-secondary-${idx}`}
            className="suite-quickbar-secondary"
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: 7,
              padding: "0 12px",
              height: 36,
              borderRadius: 8,
              backgroundColor: "#FFFFFF",
              color: "#1F2A24",
              border: "1px solid #E5E7EB",
              fontSize: 12.5,
              fontWeight: 500,
              cursor: "pointer",
              fontFamily: "var(--gis-font-body)",
              whiteSpace: "nowrap",
              flexShrink: 0,
              transition: "border-color 120ms, color 120ms",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.borderColor = "var(--gis-green)";
              e.currentTarget.style.color = "var(--gis-green)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.borderColor = "#E5E7EB";
              e.currentTarget.style.color = "#1F2A24";
            }}
          >
            {s.icon && <s.icon size={14} strokeWidth={1.75} />}
            {s.label}
          </button>
        ))}
      </div>
    </div>
  );
}

export default SuiteQuickBar;

